import React from 'react';
import { useSirenEntity } from '~/utility/BinSentry-ui-utility';
import { Link } from '~/lib/bn-material-ui';

export function SiteLink({ binHref, barnHref, siteHref, ...linkProps }) {
  // use the bin url
  const { entity: binEntity } = useSirenEntity({ href: binHref });
  const ownerHref = binEntity?.getSubEntityByRel('https://api.binsentry.com/rel/bin-owner').href;

  // or the barn url
  const { entity: barnEntity } = useSirenEntity({ href: barnHref || ownerHref });
  const farmHref = barnEntity?.getLink('https://api.binsentry.com/rel/farm')?.href;

  // or the site url directly
  const { entity: siteEntity } = useSirenEntity({ href: siteHref || farmHref });

  if (!siteEntity) {
    return null;
  }

  const orgId = siteEntity.getLink('self').href;

  return (
    <Link
      href={`/customers/?organizationId=${encodeURIComponent(orgId)}`}
      {...linkProps}
    >
      {siteEntity.properties.name}
    </Link>
  );
}
